// Fonte única do breakpoint mobile (`<768px`), espelhando o breakpoint `md` do Bootstrap.
// 767.98 evita o gap de 1px exatamente em 768px entre `max-width` (CSS) e `min-width` (grid).
export const MOBILE_MAX_WIDTH = 767.98;

export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_MAX_WIDTH}px)`;
